import { useEffect, useState } from 'react'
import pclnRequest from '@pcln/request'
import config from 'isomorphic-config'
import analytics from '../../utils/analytics'

type PCLN_GRAPH = {
  url: string
  timeout: number
}

type CITY_MAP_PROPS = {
  lat: number | undefined
  lon: number | undefined
  width: number | undefined
  height: number | undefined
}

const useFetchCityMap = ({ lat, lon, width, height }: CITY_MAP_PROPS) => {
  const [cityMapURL, setCityMapURL] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { url, timeout } = config.client['pcln-graph'] as PCLN_GRAPH
        const result = await pclnRequest({
          url,
          timeout,
          method: 'POST',
          data: {
            query: `query ($lat: Float!, $lon: Float!, $x: Int!, $y: Int!){ 
                      googleMapStatic(
                        center:{ lat: $lat, lon: $lon },
                        size: { x: $x, y: $y}
                      ) {
                        url
                      }
                    }`,
            variables: { lat, lon, x: width, y: height }
          }
        })
        setCityMapURL(result?.data?.data?.googleMapStatic?.url ?? '')
      } catch (error) {
        analytics.logError({
          message: 'Failed to load city map url'
        })
      }
    }

    if (
      lat !== undefined &&
      lon !== undefined &&
      height !== undefined &&
      width !== undefined
    ) {
      fetchData()
    }
  }, [lat, lon, width, height])

  return { cityMapURL }
}

export default useFetchCityMap
